// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionOrderUpdate
import { getAPIURL } from "assessments/utils"

export default QuestionOrderUpdate = class QuestionOrderUpdate extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  url() {
    const url = `${this.get("assessment_id")}/question/orders`
    return getAPIURL(url, this)
  }

  toJSON() {
    // Only send the updates to the server
    return this.get("updates")
  }
}
